import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import RemoteSelect2 from "./remoteSelect2";
import { openFileUrl } from "../utils/openReport";

const DATA_REPORT_DATE_TYPE = [
  { label: "Create Date", value: "createdAt" },
  { label: "Notice Date", value: "date" },
  { label: "Effective Date", value: "period.start" },
  { label: "Expiry Date", value: "period.end" },
  // { label: "Confirmed Date", value: "confirmedAt" },
  // { label: "Settled Date", value: "settledAt" },
  { label: "Policy Received Date", value: "policyReceivedAt" },
  { label: "Policy Dispatched Date", value: "policyDispatchedAt" },
];

const ReportDebitNote = ({}) => {
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [dateType, setDateType] = useState("date");
  const [loading, setLoading] = useState(false);
  const [consultant, setConsultant] = useState();
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [policyStatus, setPolicyStatus] = useState(null);

  const DATA_POLICY_STATUS = [
    { label: "None", value: "NONE" },
    { label: "Policy Received", value: "POLICY_RECEIVED" },
    { label: "Policy Dispatched", value: "POLICY_DISPATCHED" },
  ];

  const canDownload = Boolean(dateType && (fromDate || toDate));

  const downloadReport = async () => {
    try {
      setLoading(true);

      // console.log(fromDate, toDate);

      const result = await api.DebitNote.getReport({
        fromDate,
        toDate,
        dateType,
        consultant,
        policyStatus,
      });
      setLoading(false);
      // console.log(result);
      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      // console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">{t("Please select the period of records")}</Text>
      <Group mt="xs">
        <DatePicker
          title="From"
          size="xs"
          allowFreeInput
          placeholder="From"
          disabled={!dateType}
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title="To"
          size="xs"
          allowFreeInput
          placeholder="To"
          disabled={!dateType}
          onChange={(d) => setToDate(d)}
        />
        <Text size="xs">by</Text>
        <Select
          size="xs"
          data={DATA_REPORT_DATE_TYPE}
          clearable
          onChange={(type) => {
            setDateType(type);
            if (!type) {
              setFromDate(null);
              setToDate(null);
            }
          }}
        />
        <Select
          size="xs"
          data={DATA_POLICY_STATUS}
          onChange={(status) => setPolicyStatus(status ?? null)}
          clearable
          allowClear
        />
        <RemoteSelect2
          title="Consultant"
          size="xs"
          allowFreeInput
          placeholder="Select Consultant (Empty for all)"
          onDataChange={(d) => {
            if (d) {
              setConsultant(d._id);
            } else {
              setConsultant(null);
            }
          }}
          apiEntity="user"
          valueField="_id"
          labelField="name"
          labelRender={(data) =>
            `[${data.staffId}] ${data.name} ${
              data.aliasName ? `(${data.aliasName})` : ""
            }`
          }
          searchFields={["name", "staffId", "aliasName"]}
          clearable
          multiple={false}
          style={{ width: "350px" }}
          pageSize={100}
        />
      </Group>

      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
        disabled={!canDownload}
      >
        {t("Download")}
      </Button>
      {!canDownload && (
        <Text size="xs" color="dimmed" mt="xs">
          {t("debitNote.report.dateRequired")}
        </Text>
      )}
      <></>
    </div>
  );
};

export default ReportDebitNote;
